export default (context) => [
  {
    nome: context.$tc('label.acao_pendente', 2), obrigatorio: false, label: 'contratosacoespend', habilitaGrid: false, habilitaFiltro: false, desativaFiltro: false, desativaGrid: false, habilitaEdicao: true, edicaoAprovado: false,
  },
  {
    nome: context.$tc('label.descricao', 1), obrigatorio: true, label: 'descricao', habilitaGrid: true, habilitaFiltro: false, desativaFiltro: true, desativaGrid: true, habilitaEdicao: true, edicaoAprovado: false,
  },
  {
    nome: context.$tc('label.divisao', 1), obrigatorio: true, label: 'divisao', habilitaGrid: true, habilitaFiltro: true, desativaFiltro: true, desativaGrid: true, habilitaEdicao: false, edicaoAprovado: false,
  },
  {
    nome: context.$tc('label.unidade_negocio', 1), obrigatorio: true, label: 'unidadenegocio', habilitaGrid: true, habilitaFiltro: true, desativaFiltro: true, desativaGrid: true, habilitaEdicao: false, edicaoAprovado: false,
  },
  {
    nome: context.$tc('label.status', 1), obrigatorio: true, label: 'status', habilitaGrid: true, habilitaFiltro: true, desativaFiltro: true, desativaGrid: true, habilitaEdicao: false, edicaoAprovado: false,
  },
  {
    nome: context.$tc('label.habilitar_coeficiente_calculo', 1), obrigatorio: true, label: 'coeficiente_calculo', habilitaGrid: true, habilitaFiltro: false, desativaFiltro: true, desativaGrid: true, habilitaEdicao: false, edicaoAprovado: false,
  },
];
